import { EditableReferenceData } from "@/components/admin/ReferenceDataList";
import { TeamProfilePanel } from "@/components/admin/TeamProfilePanel";
import { AgentsPanel } from "@/components/admin/AgentsPanel";
import { EDITABLE_REF_TYPES } from "@/components/admin/reference-data-config";

// "Stammdaten" – the reference-data admins maintain themselves, grouped into
// settings sidebar sub-menus (STAMMDATEN_TABS): "Organisation" bundles the
// company-level reference data, "Berufserfahrung" the work-experience lookups
// and "Details" the personal lookup values. Each tab lists the ref-type keys
// it renders; the panel shows them as a uniform card grid. (Questionnaires
// have their own section/role and live in FragebogenPanel.)
//
// "Teamprofil" is the exception: a Power Profile carries weights and members,
// which the flat label/id shape of EDITABLE_REF_TYPES cannot express, so that
// tab renders its own panel instead of the card grid. "KI-Agenten" likewise: an agent carries
// two-language prose and repeatable lists.

export const STAMMDATEN_TABS = [
  {
    id: "organisation",
    labelId: "stammdaten.organisation",
    keys: ["jobDepartment", "jobLocation", "contractType", "workingTimeModel"],
  },
  { id: "experience", labelId: "stammdaten.experience", keys: ["industry", "degree"] },
  { id: "details", labelId: "stammdaten.details", keys: ["gender", "maritalStatus"] },
  { id: "teamprofil", labelId: "stammdaten.teamprofil" },
  { id: "agents", labelId: "stammdaten.agents" },
] as const;

export type StammdatenTabId = (typeof STAMMDATEN_TABS)[number]["id"];

const byKey = (key: string) => EDITABLE_REF_TYPES.find((t) => t.key === key)!;

export function StammdatenPanel({ active }: { active: StammdatenTabId }) {
  const tab = STAMMDATEN_TABS.find((t) => t.id === active) ?? STAMMDATEN_TABS[0];
  if (tab.id === "teamprofil") return <TeamProfilePanel />;
  if (tab.id === "agents") return <AgentsPanel />;
  return (
    <div className="grid grid-cols-1 items-start gap-6 @md:grid-cols-2">
      {tab.keys.map((key) => (
        <EditableReferenceData key={key} descriptor={byKey(key)} />
      ))}
    </div>
  );
}
